import options from './details-chart.component';

export default {
    selector: 'dtThingDetailsChart',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/thing-details/details-chart/index.js